module.exports = __webpack_public_path__ + "img/photo-not-found.4ba4aad7.jpeg";